module.exports = __webpack_public_path__ + "img/Speaker=Motasem Salem.7d5b63d6.png";